import CreateShow from "../components/create/Show";

export default [
  { name: 'Create', path: '/create', component: CreateShow,  }
]
